module.exports = __webpack_public_path__ + "assets/img/logo-intella-wechatpay.fbaca1e0.png";